import React from 'react';
import { useTranslation } from 'react-i18next';
import Page from 'userportal/components/Page';
import Spinner from 'shared/components/Spinner';

const Loading = () => {
  const { t } = useTranslation('userportal');

  return (
    <Page helmetTitle={t('common:seoTitle')}>
      <Spinner />
    </Page>
  );
};

export default Loading;
